<!-- 申请售后 -->
<template>
  <div class="services-view">
    <header class="order-title">
      <span class="skip" @click="toOrder">订单管理</span>
      <span class="cutApart">></span>
      <span style="font-weight:400;">申请售后</span>
    </header>
    <!-- <el-tabs>
      <el-tab-pane label="申请售后" />
    </el-tabs> -->
    <div class="orderList">
      <div class="select-service">
        <span style="color:#EC212D;">*</span>
        <span>服务类型:</span>
        <span style="margin-left:20px;color:#EC212D;font-weight:bold;">{{ orderStatus == 3 ? '直接退款' : '退货退款' }}</span>
        <div class="searvice-tips">
          <span class="red">温馨提示：</span>
          <span class="text">本次售后服务由 <span>实达实</span> 为您提供</span>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%;"
        :header-cell-style="{background:'#fff',color:'#666666'}"
      >
        <el-table-column
          prop="date"
          label="商品"
          width="550"
          align="center"
        >
          <template>
            <div class="goods">
              <div class="goodsImg">
                <el-image
                  style="width: 67px; height: 67px"
                  :src="stockInfo.FStockImagePath"
                  :preview-src-list="[stockInfo.FStockImagePath]"
                />
              </div>
              <div class="goodsInfo">
                <div class="goodsName">{{ stockInfo.FStockName }}</div>
                <!-- <div class="goodsExplain">平台商品名称: 东成 六角螺丝 8.8级加长</div>
                <div class="goodsExplain"><span>商品型号： 2190021325</span> <span>品牌：世达</span></div>
                <div class="goodsExplain">厂家货号：10450</div> -->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="FTotalPrice"
          label="单价"
          align="center"
        >
          <template slot-scope="scope">
            <div class="price">￥{{ stockInfo.FTotalPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="number"
          label="可退数量"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{ stockInfo.FQuanty - stockInfo.FApplyReturnQuanty - stockInfo.FReturnQuanty }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="money"
          label="订单金额"
          align="center"
        >
          <template slot-scope="scope">
            <div class="price">￥{{ stockInfo.FTotalAmount }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="tuihuoFrom">
      <el-form ref="showForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
        <div class="from-text">
          <!-- <el-form-item label="退款方式" prop="name">
            <div class="frist-text">原支付方式返回</div>
          </el-form-item> -->
          <el-form-item label="退款账户" prop="name">
            <div class="returnUser">
              {{ orderStatus == 3 ? '供方同意退款，增加可用额度。' : '实达实同意退货，增加可用额度。' }}
            </div>
          </el-form-item>
        </div>
        <el-form-item label="提交数量" prop="name">
          <el-input-number v-model="ruleForm.FQuanty" :precision="stockInfo.FQuantyDecimal" :min="stockInfo.min" :max="stockInfo.FQuanty - stockInfo.FApplyReturnQuanty - stockInfo.FReturnQuanty" label="描述文字" @blur="tofixeds('ruleForm','FQuanty')" @change="handleChange" />
          <span style="margin-left:20px;color:#EC212D;">温馨提示：您最多可提交数量为{{ tofixed(stockInfo.FQuanty - stockInfo.FApplyReturnQuanty - stockInfo.FReturnQuanty) }}个</span>
        </el-form-item>
        <el-form-item label="提交原因" prop="FAfterSaleReason">
          <textarea v-model="ruleForm.FAfterSaleReason" class="fromTextarea" maxlength="50" placeholder="请输入50字以内原因" />
        </el-form-item>
        <el-form-item label="图片信息">
          <div style="display:flex">
            <span v-for="(item,index) in ruleForm.FAfterSaleImg" :key="index" class="prod-picture-list" @mouseenter="pictureEnters(index)" @mouseleave="pictureLeaver(index)">
              <div v-if="picHover === index" class="prod-picture-hover">
                <i class="el-icon-delete" @click="handleRemove(index)" />
              </div>
              <img v-if="item" :class="chooseDefaultIndex === index? 'default-border': 'prod-picture'" :src="item" alt="">
            </span>
            <el-upload
              v-if="ruleForm.FAfterSaleImg.length !== 3"
              action="Fake Action"
              :show-file-list="false"
              :auto-upload="false"
              class="prod-picture-upload"
              :on-change="(file) => {
                coverImgChange(file,showIndex)
              }"
            >
              <div class="upload-style">
                <div>
                  <i style="font-size:26px;" class="el-icon-picture-outline" />
                  <div class="upload-text">上传图片</div>
                </div>
              </div>
            </el-upload>
            <span style="color:#EC212D;margin-left:15px;line-height: 20px;padding-top: 94px;">温馨提示：最多上传3张图片</span>
          </div>
        </el-form-item>

        <!-- <div style="width:50%;padding-left:2%;">

          </div> -->
        <!-- <el-form-item style="margin-top: 30px;">
          <div class="service-btn">
            <el-button class="btn" type="primary" @click="submitForm('showForm')">确认提交</el-button>
          </div>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="cfmReturn">
      退款金额：<span style="color:#EC212D;margin-left:15px;font-weight: bold;">-￥{{ returnPrice }}</span>
      <el-button class="btn" type="primary" @click="submitForm('showForm')">确认提交</el-button>
    </div>
  </div>
</template>

<script>
import { uploadImg } from '@/api/user.js'
import { refundOrder } from '@/api/order.js'
export default {
  data() {
    return {
      tableData: [{
        price: '30',
        number: '2',
        money: '60'
      }],
      uploadDisabled: false,
      gameNames: ['退货', '换货'],
      activeName: '',
      ruleForm: {
        name: '111',
        resource: 1,
        FAfterSaleReason: '',
        FQuanty: 1,
        FAfterSaleImg: [],
        ftype: 1
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        resource: [{ required: true, trigger: 'blur' }],
        FAfterSaleReason: [{ required: true, message: '请输入提交原因', trigger: 'blur' }],
        img: [{ required: true, trigger: 'blur' }]
      },
      stockInfo: {},
      orderStatus: 3,
      chooseDefaultIndex: null,
      showIndex: null,
      picHover: null,
      loading: null
    }
  },
  computed: {
    returnPrice() {
      const price = this.ruleForm.FQuanty * this.stockInfo.FTotalPrice
      return this.getFloat(price, 2)
    }
  },
  created() {
    const obj = JSON.parse(this.$route.query.stockInfo)
    const min = this.countDecimal(obj.FQuantyDecimal)
    obj.min = min
    this.ruleForm.FQuanty = obj.FQuanty - obj.FApplyReturnQuanty - obj.FReturnQuanty
    this.stockInfo = obj
    this.orderStatus = this.$route.query.orderStatus
    this.ruleForm.ftype = this.orderStatus == 3 ? 1 : 2
  },
  methods: {
    countDecimal(val) {
      let min = '0.'
      for (let i = 1; i < val; i++) {
        min += '0'
      }
      return Number(min + '1')
    },
    tofixeds(key, val) {
      const value = this[key][val]
      const nums = isNaN(Number(value)) ? 0 : Number(value)
      this[key][val] = nums.toFixed(this.stockInfo.FQuantyDecimal)
    },
    toOrder() {
    //   console.log(this.$route.query.orderStatus)
      this.$router.push({
        name: 'MyOrderManagement',
        params: {
          orderStatus: this.$route.query.orderStatus
        }
      })
    },
    handleRemove(i) {
      this.ruleForm.FAfterSaleImg.splice(i, 1)
      this.picHover = null
    },
    coverImgChange(file, i) {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const formData = new FormData()
      formData.append('file', file.raw)
      uploadImg(formData)
        .then(res => {
          if (res.imgUrlList[0].result) {
            this.ruleForm.FAfterSaleImg.push(res.imgUrlList[0].oriUrl)
          } else {
            this.$message.error(res.imgUrlList[0].message)
          }
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    tofixed(num) {
      return Number(num).toFixed(this.stockInfo.FQuantyDecimal)
    },
    getFloat(number, n) {
      n = n ? parseInt(n) : 0
      if (n <= 0) {
        return Math.round(number)
      }
      number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n) // 四舍五入
      number = Number(number).toFixed(n) // 补足位数
      return number
    },
    selected: function(item) {
      this.activeName = item
    },
    handleChange(value) {
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const jsonobj = JSON.parse(JSON.stringify(this.ruleForm))
          delete jsonobj.name
          delete jsonobj.resource
          jsonobj.FAfterSaleImg = jsonobj.FAfterSaleImg.toString()
          const params = new URLSearchParams()
          params.append('id', this.stockInfo.fdetailID)
          params.append('jsonobj', JSON.stringify(jsonobj))
          refundOrder(params)
            .then(res => {
              this.loading.close()
              if (res.result) {
                this.$message.success(res.msg)
                this.$router.push({
                  path: '/order/orderManagement'
                })
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {
              this.loading.close()
            })
        } else {
          return false
        }
      })
    },
    /**
     * 鼠标移入商品图片事件
     */
    pictureEnters(index) {
      this.picHover = index
      this.noPrcHover = ''
    },
    /**
     * 鼠标移出商品图片事件
     */
    pictureLeaver() {
      this.picHover = ''
    },
    handlePreview(file) {
    }
  }
}
</script>

<style lang="scss">
.prod-picture-list{
  position: relative;
  margin-right: 13px;
  display: flex;
  flex-direction: column;
  text-align: center;
  .prod-picture{
    width: 114px;
    height: 114px;
    border: 1px solid #D2D2D2;
    pointer-events:none;
  }
  .set-defult{
      position: absolute;
      top: 108px;
      left: 50%;
      transform: translateX(-50%);
    font-size: 12px;
    color: #2DB0A0;
    text-decoration: underline;
  }
  .default-border{
    width: 114px;
    height: 114px;
    border: 1px dashed #D2D2D2;
    pointer-events:none;

  }
  .prod-picture-hover{
    width: 114px;
    height: 114px;
    // background-color: #000;
    // opacity: 0.7;
    background-color:rgba(0,0,0,0.5);
    position: absolute;
    line-height: 114px;
    text-align: center;
    .el-icon-delete:before{
      color: #fff;
      cursor: pointer;
    }
    .el-checkbox:last-of-type {
        position: absolute;
        right: -75px;
        // margin-right: -20px;
    }
  }
}
.services-view{
  background: #F3F3F3;
  padding: 8px;
  height: 100%;
//   overflow-y: auto;
  display: flex;
  flex-direction: column;
      .order-title {
        background-color: #fff;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        padding-left: 32px;
        .skip {
            cursor: pointer;
            font-weight: bold;
        }
        .cutApart {
            font-weight: bold;
            margin: 0 5px;
        }
        span {

        }
    }
  .search-title{
    display: flex;
    justify-content: space-between;
    width:100%;
    height: 36px;
    line-height: 36px;
    background-color: #EC212D;
    .title-text{
      cursor: pointer;
      color:#fff;
      font-size: 16px;
      margin-left: 11px;
    }
  }
   .el-tabs__item{
    width: 132px;
    height: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    // color: #666666;
    line-height: 60px;
    text-align: center;
  }
  .goods{
            min-width: 550px;
            display: flex;
             box-sizing: border-box;
            padding: 10px 20px 10px 10px;
            .goodsImg{
              width: 67px;
              height: 66px;
              margin-right: 13px;
              img{
                 width: 67px;
                height: 66px;
              }
            }
            .goodsInfo{
              flex: 1;
              .goodsName{
                font-size: 14px;
                height: 66px;
                line-height: 66px;
                font-family: SimSun;
                font-weight: 400;
                color: #333333;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
                text-align: center;
              }
              .goodsExplain{
                width: 100%;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                font-family: SimSun;
                font-weight: 400;
                color: #999999;
                 box-sizing: border-box;
                 padding: 0 30px 0 0px;
              }
            }
        }
   .searvice-tips{
       float: right;
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      margin-right: 20px;
     .red{
      color: #EC212D;
     }
     .text{
      color: #999999;
      span{
        color: #EC212D;
      }
     }
     .red::before{
        content: '*';
        color: #EC212D;
      }
   }
  .select-service{
    background: #fff;
    min-height: 50px;
    line-height: 50px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding-left: 32px;
    margin-top: 10px;
     .active{
      color: #FF812C;
      background: #FFE4D2;
      border: 1px solid #FF812C !important;
      cursor:pointer
    }
    .collection-item{
      width: 130px;
      height: 30px;
      border: 1px solid #CDCDCD;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      cursor:pointer
    }
    .collection-item:hover{
      border: 1px solid #FF812C !important;
      border-radius: 2px;
      color: #FF812C;
      cursor:pointer
    }
  }

  .tuihuoFrom{
      background-color: #fff;
    //   border: 1px solid #EBEEF5;
      padding: 24px 15px 50px 10px;
    // margin: 0 100px;
    font-size: 14px;
    font-family: SimSun;
    font-weight: 400;
    color: #333333;
     .el-form-item{
        width: 100%;
      }
      .el-form-item__label{
        font-size: 14px;
        font-family: SimSun;
        font-weight: 400;
        color: #999999;
      }
      .el-upload--picture-card {
          width: 100px;
          height: 100px;
      }
      .el-upload-list__item {
          width: 100px;
          height: 100px;
      }
    .el-input-number .el-input__inner{
      height: 36px;
    }
    .el-input-number__increase, .el-input-number__decrease {
    position: absolute;
    z-index: 1;
    top: 2px;
    width: 40px;
    height: 34px;
    text-align: center;
    background: #F5F7FA;
    color: #606266;
    cursor: pointer;
    font-size: 13px;
}
    // .el-input-number__increase{
    //   top: 3px;
    // }
    .from-text{
      display: flex;
      align-items: center;
      height: 50px;
    //   margin-bottom: 15px;
    //   border-bottom: 1px dashed rgba($color: #000, $alpha: 0.1);
      .returnUser {
          background:#f8f6f7;
          border: 1px solid #EBEEF5;
          border-radius: 6px;
          padding-left: 10px;
      }
      .frist-text{
        width: 180px;
        height: 30px;
        background: rgba($color: #2475EA, $alpha: 0.1);
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: SimSun;
        font-weight: 400;
        color: #333333;
        margin-top: 5px;
      }
    }
    .fromTextarea{
      height: 40px;
      width:100%;
      background: #FFFFFF;
      border: 1px solid #D2D2D2;
      box-sizing: border-box;
      padding: 10px;
    }
    .service-btn{
      min-width: 800px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      padding-right: 13px;
    }
.el-upload {
    caret-color: transparent;
    .upload-style {
        width: 114px;
        height: 114px;
        border: 1px dashed #D2D2D2;
        border-radius: 5px;
        font-size: 12px;
        color: #D2D2D2;
        display: flex;
        justify-content: center;
        align-items: center;
        .upload-text {
            height: 20px;
            line-height: 20px;
        }
    }
    .upload-style>div {
        height: 60px;
    }
    .upload-style:hover {
        border-color: #EC212D;
    }
  .uploadDiv {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .svg-icon {
    width: 39px;
    height: 33px;
    }
    .uploadText {
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      color: #D2D2D2;
      line-height: 30px;
    }
    }
    }
  }
  .cfmReturn {
      background-color: #fff;
      margin: 10px 0 30px;
      padding-left: 32px;
      height: 64px;
      line-height: 64px;
      border: 1px solid #EBEEF5;
      color: #999999;
      .btn{
          float: right;
          width: 220px;
          height: 62px;
          border-radius: 0;
          background: #EC212D;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
      }
  }
}
</style>
